import type { ReactNode } from 'react'

import { cn } from '@jotta/utils/css'

import { BizBoundary } from '../components/BizBoundary'

export function BizWidget({
  title,
  children,
  className,
  bodyClassName,
}: {
  title: ReactNode
  children: React.ReactNode
  className?: string
  bodyClassName?: string
}) {
  return (
    <BizBoundary>
      <div className={cn('card card-outline rounded-xl p-0', className)}>
        <h2 className="p-6 pb-3 text-xl font-medium">{title}</h2>
        <div className={cn('card-body px-6 pb-6', bodyClassName)}>
          {children}
        </div>
      </div>
    </BizBoundary>
  )
}
